import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import UpClubBanner from "../components/UpClubBanner";
import { Shield, Zap, Sticker, Wrench, Gift, Smartphone, Headphones } from "lucide-react";

const BENEFITS = [
  { icon: Sticker, title: "Película Hidrogel HD grátis", desc: "1 troca gratuita a cada 3 meses" },
  { icon: Shield, title: "3 meses extras de garantia", desc: "Em cima da garantia normal de qualquer reparo" },
  { icon: Wrench, title: "10% off em serviços", desc: "Manutenção, troca de tela, bateria, conector..." },
  { icon: Headphones, title: "15% off em acessórios", desc: "Fones, cabos, carregadores, capinhas" },
  { icon: Smartphone, title: "5% off em celulares novos", desc: "Toda a linha de aparelhos" },
  { icon: Gift, title: "Atendimento prioritário", desc: "Fila preferencial na loja e no WhatsApp" },
];

export default function UpClubJoin() {
  const [params] = useSearchParams();
  const preselect = params.get("plan"); // 'monthly' | 'annual' (opcional)
  const [autoOpened, setAutoOpened] = useState(false);

  // Se o link veio com ?plan=monthly ou ?plan=annual, abre o modal automaticamente
  useEffect(() => {
    if (!preselect || autoOpened) return;
    if (preselect !== "monthly" && preselect !== "annual") return;
    const btn = document.querySelector(`[data-testid="upclub-${preselect}-btn"]`);
    if (btn) {
      setTimeout(() => { btn.click(); setAutoOpened(true); }, 500);
    }
  }, [preselect, autoOpened]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-indigo-950 to-slate-950 text-white">
      <header className="max-w-4xl mx-auto px-4 pt-6 pb-2 flex items-center justify-between">
        <Link to="/catalog" className="text-xs uppercase tracking-[0.25em] text-indigo-300 hover:text-white font-semibold">
          ← UP CEL Quilombo
        </Link>
        <Link to="/upclub/manage" className="text-xs text-indigo-300 hover:text-white underline">
          Já sou membro
        </Link>
      </header>

      <main className="max-w-4xl mx-auto px-4 pb-16">
        <UpClubBanner />

        <section className="mt-8">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-center mb-2">
            Tudo que você ganha ao virar membro
          </h2>
          <p className="text-slate-400 text-sm text-center mb-8 max-w-xl mx-auto">
            Programa exclusivo pra quem é cliente UP CEL Quilombo. Cancela quando quiser.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {BENEFITS.map((b) => {
              const Icon = b.icon;
              return (
                <div
                  key={b.title}
                  className="flex gap-3 p-4 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm"
                >
                  <div className="flex-shrink-0 w-10 h-10 rounded-lg bg-indigo-500/20 border border-indigo-400/30 flex items-center justify-center">
                    <Icon size={18} className="text-indigo-300" />
                  </div>
                  <div>
                    <div className="font-semibold text-sm">{b.title}</div>
                    <div className="text-xs text-slate-400 mt-0.5">{b.desc}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </section>

        <section className="mt-10 bg-white/5 border border-white/10 rounded-2xl p-6 text-center">
          <Zap className="inline text-amber-400 mb-2" size={28} />
          <h3 className="font-display text-xl font-bold mb-2">Ativação imediata</h3>
          <p className="text-sm text-slate-300 max-w-md mx-auto leading-relaxed">
            Assim que o pagamento é aprovado pelo Mercado Pago, sua conta é ativada automaticamente e você já pode usar os benefícios na próxima visita à loja.
          </p>
        </section>

        <section className="mt-6 text-center text-xs text-slate-500">
          Dúvidas? Fala com a gente no{" "}
          <a
            href="https://wa.me/5549998122884"
            target="_blank" rel="noreferrer"
            className="text-emerald-400 hover:text-emerald-300 font-semibold"
          >
            WhatsApp
          </a>
        </section>
      </main>
    </div>
  );
}
